export { default } from './FattyCartDrawer';
export { default as FattyCartDrawer } from './FattyCartDrawer';
